export default "__VITE_ASSET__D7F7Nl8p__"